<app-waves-js *ngIf="isShowNav && (isLoggedIn$ | async)===false"></app-waves-js>
<nz-layout>
  <nz-sider *ngIf="isShowNav && (isLoggedIn$ | async)"
            nzCollapsible [nzWidth]=180 [nzCollapsedWidth]=38 class="niq-sidebar"
            [nzCollapsed]="isCollapsed"
            [nzTrigger]="null">
    <app-sidebar [resetNav]="resetNav" [isCollapsed]="isCollapsed" (collapsedEvt)="this.isCollapsed = !this.isCollapsed"></app-sidebar>
  </nz-sider>
  <nz-layout [ngClass]="{'ant-layout-fixed-header': false}">
    <!--<app-header *ngIf="isShowNav"></app-header>-->

    <nz-content [ngClass]="{'customize-content': !isShowNav || (isLoggedIn$ | async)===false}">
      <ng-content></ng-content>
      <!-- <app-footer></app-footer> -->
    </nz-content>

  </nz-layout>
</nz-layout>

<div *ngIf='showBlockTime' class='block-box'>
  <p>Sorry for the inconvenience, MyEcom is now under routine maintenance during
    <span class='niq-red'>{{ showBlockTime }}</span>.
    <br>During this maintenance window, service will be inaccessible.
    Thank you for your patience and support.
  </p>
</div>
